// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-raised-button.mat-blue {
  background-color: #5479b9;
  color: white;
}

.mat-mdc-raised-button.mat-gray {
  background-color: #c7c7c7;
  color: white;
}

.error {
  color: #c3002f;
}

.justify-end {
  justify-content: end;
}

/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */
:host ::ng-deep .mat-card-header-text {
  height: auto;
  width: 0px;
  margin: 0px;
}

.mat-mdc-card-title-group {
  width: 70%;
  margin-top: 5px;
}

.main-content {
  margin: 0 auto;
  max-width: 1920px;
  padding: 16px 35px;
}`, "",{"version":3,"sources":["webpack://./src/app/public/surveys/data-entry-page/data-entry-page.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA,2HAAA;AACA;EACE,YAAA;EACA,UAAA;EACA,WAAA;AACF;;AAEA;EACE,UAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AACF","sourcesContent":[".mat-mdc-raised-button.mat-blue {\r\n  background-color: #5479b9;\r\n  color: white;\r\n}\r\n\r\n.mat-mdc-raised-button.mat-gray {\r\n  background-color: #c7c7c7;\r\n  color: white;\r\n}\r\n\r\n.error {\r\n  color: #c3002f;\r\n}\r\n\r\n.justify-end {\r\n  justify-content: end;\r\n}\r\n\r\n/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */\r\n:host ::ng-deep .mat-card-header-text {\r\n  height: auto;\r\n  width: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n.mat-mdc-card-title-group {\r\n  width: 70%;\r\n  margin-top: 5px;\r\n}\r\n\r\n.main-content {\r\n  margin: 0 auto;\r\n  max-width: 1920px;\r\n  padding: 16px 35px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
